import request from '@/libs/request'

// 猪场检疫检疫记录 列表
export function pigQuarantineListApi (data) {
  return request({
    url: `pigFarm/pigQuarantine`,
    method: 'get',
    params: data
  })
}

// 猪场检疫检疫记录 详情
export function pigQuarantineDetailApi (id) {
  return request({
    url: `pigFarm/pigQuarantine/` + id,
    method: 'get'
  })
}


// 猪场检疫检疫记录 编辑/添加
export function pigQuarantineSaveApi (data) {
  return request({
    url: `pigFarm/pigQuarantine`,
    method: 'post',
    data: data
  })
}

// 猪场检疫检疫记录 删除
export function pigQuarantineDelApi (id) {
  return request({
    url: `pigFarm/pigQuarantine/` + id,
    method: 'delete'
  })
}


